import { useDispatch, useSelector } from "react-redux";
import {
  pc9Fetch as pc9FetchAction
} from "./store/phototool.actions";
import { reduxActions as PHOTOTOOL } from "./phototool.constants";

const usePhototool = () => {
  const dispatch = useDispatch();

  const {
    data: pc9Data,
    error: pc9Error,
    status: pc9Status 
  } = useSelector((s) => s?.module?.phototool?.pc9);

  const pc9Reset = () => dispatch({ type: PHOTOTOOL.FETCH_PC9_RESET });

  /**
   * 
   * @param {Object} data 
   * @param {Object} extras 
   * @returns 
   */
  const pc9Fetch = (data, extras = {}) => dispatch(pc9FetchAction(data, {
    feedback: {
      error: true,
      success: false
    },
    ...extras
  }));

  return {
    pc9Fetch,
    pc9Data,
    pc9Error,
    pc9Reset,
    pc9Status
  };
};

export default usePhototool;
